import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[ContractCategories SetFilter] Action',
  ResetFilter: '[ContractCategories ResetFilter] Action',
}

const initialContractCategoriesState: IContractCategoriesState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IContractCategoriesState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-ContractCategories', whitelist: ['filter']},
  (
    state: IContractCategoriesState = initialContractCategoriesState,
    action: ActionWithPayload<IContractCategoriesState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialContractCategoriesState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
